<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :hide-separators="true"
      :has-actions="true"
      :title="'Notifications'">
      <a
        slot="dropdown-content"
        @click="openUserNotificationQuickview"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-bells"></i></span>
        <span class="is-margin-left-xsmall">Gérer vos notifications</span>
      </a>
      <a
        slot="dropdown-content"
        v-if="canPatchAll"
        @click="patchAllEvents"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fal fa-check-circle"></i></span>
        <span class="is-margin-left-xsmall">Marquer les notifications comme lues</span>
      </a>
      <a
        slot="dropdown-content"
        v-if="canDeleteAll"
        @click="deleteAllEvents"
        class="dropdown-item has-background-danger has-text-white">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span>
        <span class="is-margin-left-xsmall">Tout supprimer</span>
      </a>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-padd-right-normal="true">
      <spinner-round
        :loading="loading"
        v-if="loading"></spinner-round>
      <div v-else>
        <div
          class=""
          v-if="timeline && timeline.length">
          <transition-group
            class="column is-paddingless is-12 is-border has-background-white"
            enter-active-class="animista enter"
            leave-active-class="animista exit"
            move-class="transition"
            tag="div">
            <template v-for="(eventParent, index) in timeline">
              <div
                v-if="eventParent.showDayLabel"
                :key="eventParent.event.pk + Date.now()"
                :class="{'is-border-top' : index !== 0}"
                class="column has-background-light is-padding-top-xsmall is-padding-bottom-xsmall il-padding-lest-small is-border-bottom is-size-7 has-text-grey is-sticky-in-mainColumn">
                <strong>{{ eventParent.date | dtFormat('dddd') | cap }} {{ eventParent.date | dtFormat('DD') }} {{ eventParent.date | dtFormat('MMMM') | cap }}</strong>
              </div>
              <line-notification
                v-if="eventParent.event.link"
                :href="eventParent.event.link"
                :key="eventParent.event.pk"
                class="is-border-bottom"
                @removeEvent="removeEvent"
                :event="eventParent.event"
                :since="eventParent.event.created_on | timeDelta"
                :title="eventParent.event.title"
                :action="'remove'"
                :description="eventParent.event.description"
                :display-noti-settings-btn="true"
                :display-vertical-actions="false"></line-notification>
              <line-notification
                v-else
                :key="eventParent.event.pk"
                class="is-border-bottom"
                @removeEvent="removeEvent"
                :event="eventParent.event"
                :since="eventParent.event.created_on | timeDelta"
                :title="eventParent.event.title"
                :action="'remove'"
                :description="eventParent.event.description"
                :display-noti-settings-btn="true"
                :display-vertical-actions="false"></line-notification>
            </template>
          </transition-group>
        </div>
        <div v-else>
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucune notification disponible
            </h2>
          </div>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { Quickview } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'EventList',
  components: {
    LineNotification: () => import('@/components/notifications/LineNotification')
  },
  mixins: [Quickview],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState(['currentUser', 'events']),
    ...mapGetters(['sortedEvents', 'newEvents']),
    /**
      * timeline
      * @returns {Array}
      */
    timeline () {
      let timeline = []
      if (this.listedEvents && this.listedEvents.length) {
        return this.listedEvents.map(x => {
          let date = moment(x.date).format('DD/MM/YYYY')
          if (timeline.includes(date) === false) {
            this.$set(x, 'showDayLabel', true)
            timeline.push(date)
          }
          return x
        })
      } else {
        return []
      }
    },
    /**
      * Create new array of object
      * @returns {Array}
      */
    listedEvents () {
      return this.sortedEvents.map(x => {
        return {
          event: Object.assign({}, x),
          date: x.created_on,
          showDayLabel: false
        }
      })
    },
    /**
      * can patch all events if there is newEvents
      * @returns {boolean}
      */
    canPatchAll () {
      return this.newEvents.length > 0
    },
    /**
      * can delete all events if there is event
      * @returns {boolean}
      */
    canDeleteAll () {
      return this.events.length > 0
    }
  },
  methods: {
    /**
      * patch all event to pass is_new to false
      */
    async patchAllEvents () {
      const params = {
        is_new: false
      }
      try {
        await this.$api.axios.patch('events', params)
        this.$store.dispatch('loadEvents')
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * Delete all events
      */
    async deleteAllEvents () {
      this.loading = true
      try {
        await this.$api.axios.delete(`events`)
        this.$store.dispatch('loadEvents')
        this.loading = false
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Impossible de supprimer toutes les notifications')
        this.loading = false
      }
    },
    /**
      * Delete one from store events
      * @param {string} eventPk - pk of the event
      */
    async removeEvent (eventPk) {
      try {
        await this.$store.dispatch('removeEvent', eventPk)
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Impossible de supprimer cet evenement')
      }
    }
  }
}
</script>
